import { ImageSourcePropType } from 'react-native'
import { Route } from './types'

type RouteNames = {
  [P in Route['name']]: ImageSourcePropType | undefined
}

const icons: {
  [P in string]:
    | {
        enabled: {
          light: ImageSourcePropType
          dark?: ImageSourcePropType
        }
        disabled?: {
          light: ImageSourcePropType
          dark?: ImageSourcePropType
        }
      }
    | undefined
} = {
  schedule: {
    enabled: {
      light: require('assets/routes/schedule/Calendar.png'),
      dark: require('assets/routes/schedule/Calendar_dark.png'),
    },
    disabled: {
      light: require('assets/routes/schedule/Calendar_disabled.png'),
      dark: require('assets/routes/schedule/Calendar_disabled_dark.png'),
    },
  },
  notifications: {
    enabled: {
      light: require('assets/routes/notifications/notifications.png'),
    },
  },
  conversations: {
    enabled: {
      light: require('assets/routes/chat/Messaging.png'),
      dark: require('assets/routes/chat/Messaging_dark.png'),
    },
    disabled: {
      light: require('assets/routes/chat/Messaging_disabled.png'),
      dark: require('assets/routes/chat/Messaging_disabled_dark.png'),
    },
  },
  open_shifts: {
    enabled: {
      light: require('assets/routes/open_shifts/Next.png'),
      dark: require('assets/routes/open_shifts/Next_dark.png'),
    },
  },
  tools: {
    enabled: {
      light: require('assets/routes/group/Group.png'),
      dark: require('assets/routes/group/Group_dark.png'),
    },
    disabled: {
      light: require('assets/routes/group/Group_disabled.png'),
      dark: require('assets/routes/group/Group_disabled_dark.png'),
    },
  },
  account: {
    enabled: {
      light: require('assets/routes/account/Profile.png'),
      dark: require('assets/routes/account/Profile_dark.png'),
    },
    disabled: {
      light: require('assets/routes/account/Profile_disabled.png'),
      dark: require('assets/routes/account/Profile_disabled_dark.png'),
    },
  },
}

function getAsset(name: string, darkMode?: boolean, disabled?: boolean) {
  const icon = icons[name]

  if (!icon) {
    return
  }

  if (disabled && icon.disabled) {
    if (darkMode && icon.disabled.dark) {
      return icon.disabled.dark
    }

    return icon.disabled.light
  }

  if (darkMode && icon.enabled.dark) {
    return icon.enabled.dark
  }

  return icon.enabled.light
}

export function getIcons(darkMode: boolean, disabled?: boolean) {
  const homeRouteIcons: Partial<RouteNames> = {
    home: undefined,
    schedule: getAsset('schedule', darkMode),
    notifications: getAsset('notifications'),
    conversations: getAsset('conversations', darkMode, disabled),
    open_shifts: getAsset('open_shifts', darkMode),
    tools: getAsset('tools', darkMode, disabled),
    account: getAsset('account', darkMode, disabled),
  }

  return homeRouteIcons as RouteNames
}
